import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { APP_SELECTOR } from 'src/constants/index';
import { App } from 'src/components/pages/index';
import { store } from 'src/store';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.min.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './style.scss';
import './main-theme.scss';

const appNode: HTMLElement = document.querySelector(APP_SELECTOR);

if (appNode) {
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>,
    appNode,
  );
}

reportWebVitals();
